import React, { useRef, useState } from 'react';
import { BrowserHistory, createBrowserHistory } from 'history';
import { Router } from 'react-router';
import { State } from './browser.utils';
import { useCompositionFetcher } from './useCompositionFetcher';
import { useLeavingGuard } from '../../hooks/LeavingGuard/useLeavingGuard';
import { Composition } from '../../types/api/Composition';
import { GenericPage } from '../../_pages/GenericPage/GenericPage';

export type RoutedPageProps = { composition: Composition };

export function RoutedPage({ composition }: RoutedPageProps) {
  const historyRef = useRef<BrowserHistory>(null);
  if (historyRef.current == null) {
    historyRef.current = createBrowserHistory();
  }

  const history = historyRef.current;
  const [state, setState] = useState<State>({
    action: history.action,
    location: history.location,
  });

  const { fetchedComposition } = useCompositionFetcher(composition, state);
  useLeavingGuard(
    history,
    state,
    setState,
    fetchedComposition.pageInfo?.pageLockReleaseUrl,
    fetchedComposition.headMetaInfo?.id,
    fetchedComposition.userInfo?.userId,
    fetchedComposition.editModeInfo?.active,
  );
  return (
    <Router navigator={history} location={state.location} navigationType={state.action}>
      <GenericPage composition={fetchedComposition} />
    </Router>
  );
}
